export default __webpack_public_path__ + "media/MAG_169px_76px-04.png";